import React from "react";

const Custombutton = ({ href, className, label, onclick, style }) => {
  return (
    <button className={className} onClick={href ? () => {
      if (href) {
        window.location.href = href; // Redirect to the passed href
      }
    } : onclick} style={style}>
      {label}
    </button >
  );
};

export default Custombutton;
